import { render, staticRenderFns } from "./addcalendar.vue?vue&type=template&id=3d5ccc3a&scoped=true&"
import script from "./addcalendar.vue?vue&type=script&lang=js&"
export * from "./addcalendar.vue?vue&type=script&lang=js&"
import style0 from "./addcalendar.vue?vue&type=style&index=0&id=3d5ccc3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ccc3a",
  null
  
)

export default component.exports